import state from './callioState'
import mutations from './callioMutations'
import getters from './callioGetters'
import actions from './callioActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
